// extracted by mini-css-extract-plugin
export default {"sec":"Contact_sec__6EgRT","error":"Contact_error__hcaka"};